/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Modal/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import FileUploaderDashboardModal from 'DesignSystem/FileUploaderDashboardModal/react'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import React from 'react'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/** @type {import('Simple/types.js').View} */
export default function Modal({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/UploadFromDesktop/Content/Modal"
  
}) {
let onClose = fromHelpers.useOnClose({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="Modal.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<FileUploaderDashboardModal
  viewPath={`${viewPath}/FileUploaderDashboardModal`}
 isOpen={true}
 onClose={onClose}
/>
<FileUploaderPluginS3
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 isLegacyBucket={true}
 excludeKeyFileExtension={true}
 prefix="tmpimg"
/>
</ViewsModalOverlay>
{children}
</React.Fragment>)
}